import { render, staticRenderFns } from "./BeoOrderSummary.vue?vue&type=template&id=95bff9a0&scoped=true"
import script from "./BeoOrderSummary.vue?vue&type=script&lang=ts"
export * from "./BeoOrderSummary.vue?vue&type=script&lang=ts"
import style0 from "./BeoOrderSummary.vue?vue&type=style&index=0&id=95bff9a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bff9a0",
  null
  
)

export default component.exports